import { render, staticRenderFns } from "./CourseNameHeader.vue?vue&type=template&id=556b3048&scoped=true"
import script from "./CourseNameHeader.vue?vue&type=script&lang=js"
export * from "./CourseNameHeader.vue?vue&type=script&lang=js"
import style0 from "./CourseNameHeader.vue?vue&type=style&index=0&id=556b3048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556b3048",
  null
  
)

export default component.exports